
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBillingItemsGrid extends Serenity.EntityGrid<ProductBillingItemsRow, any> {
        protected getColumnsKey() { return ProductBillingItemsColumns.columnsKey; }
        protected getDialogType() { return ProductBillingItemsDialog; }
        protected getIdProperty() { return ProductBillingItemsRow.idProperty; }
        protected getInsertPermission() { return ProductBillingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductBillingItemsRow.localTextPrefix; }
        protected getService() { return ProductBillingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}